<template>
	<v-col class="registrasi">
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<template v-if="!loaderData">
			<div class="d-flex justify-space-between">
				<div class="text-h5 cl-primary">{{ pageTitle }}</div>
			</div>
			<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
				<router-link to="/">
					<div class="d-flex">
						<v-icon small color="grey">mdi-home</v-icon>
						<div class="pl-2 grey--text">Dashboard</div>
					</div>
				</router-link>

				<div class="px-2">/</div>
				<div>Jaringan</div>
				<div class="px-2">/</div>
				<div>{{ pageTitle }}</div>
			</div>

			<template v-if="isMitraExist">
				<div class="mt-5">
					<v-row>
						<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
							<v-col cols="12" sm="12" md="4" class="align-stretch pt-5">
								<v-form ref="formCloningAccount" role="form" autocomplete="off">
									<v-row>
										<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3">
											<v-card class="pa-4 elevation-0 rounded-lg" outlined>
												<div class="font-size-14 cl-primary">Data Jaringan &amp; Serial</div>
												<div class="pt-2 mb-0">
													<v-text-field label="Kode Sponsor" color="primary" hide-details="auto" v-model="params.sponsor_code" tabindex="0" ref="sponsorCode" :rules="rules.sponsor_code" @focus="$event.target.select()" @blur="getMitraSponsorName(params.sponsor_code)"></v-text-field>
													<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
														{{ sponsor_name }}
													</div>
												</div>
												<div class="pt-2">
													<v-text-field label="Kode Upline" ref="uplineCode" color="primary" hide-details="auto" v-model="params.upline_code" tabindex="1" :rules="rules.upline_code" @focus="$event.target.select()" @blur="getMitraUplineName(params.upline_code)"></v-text-field>
													<div class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
														{{ upline_name }}
													</div>
												</div>
												<div class="pt-2 pb-0 mt-4">
													<v-card outlined dense class="py-1 px-3 mb-0 elevation-0 rounded-lg">
														<v-card-subtitle class="py-0 pt-2 px-0 font-weight-bold">Posisi jaringan</v-card-subtitle>
														<v-radio-group
															v-model="params.position"
															ref="position"
															row
															hide-details="auto"
															class="mb-2"
															:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
															:rules="rules.position"
														>
															<v-radio
																label="Kiri"
																value="L"
																ref="positionL"
																tabindex="2"
															></v-radio>
															<v-radio
																label="Kanan"
																value="R"
																ref="positionR"
																tabindex="2"
															></v-radio>
														</v-radio-group>
													</v-card>
												</div>

												<div class="pt-2 mb-2" v-if="false">
													<v-autocomplete 
														v-model="params.membership_serial"
														:items="listSerialRegis"
														color="primary"
														label="Serial Registrasi"
														hide-details="auto"
														item-text="id"
														item-value="id"
														no-data-text="Tidak ada data"
														tabindex="3"
														class="group-autocomplete"
														:rules="rules.input"
													>
														<template v-slot:selection="data">
															<span class="gray--text lighten-5">{{ data.item.serial_member_stock_serial_id }}</span>
														</template>
														<template v-slot:item="data">
															<template v-if="(typeof data.item) !== 'object'">
																<v-list-item-content v-text="data.item"></v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content>
																	<v-list-item-title v-html="data.item.serial_member_stock_serial_id"></v-list-item-title>
																</v-list-item-content>
															</template>
														</template>
													</v-autocomplete>
												</div>

												<div class="pt-2 mb-2">
													<v-autocomplete 
														v-model="params.network_serial"
														:items="listSerialActivation"
														color="primary"
														label="Serial Aktivasi"
														hide-details="auto"
														item-text="id"
														item-value="id"
														no-data-text="Tidak ada data"
														tabindex="4"
														class="group-autocomplete"
														:rules="rules.input"
													>
														<template v-slot:selection="data">
															<span class="gray--text lighten-5">{{ data.item.id }}</span> <span class="cl-secondary ml-2">( {{ data.item.group.toUpperCase() }} )</span>
														</template>
														<template v-slot:item="data">
															<template v-if="(typeof data.item) !== 'object'">
																<v-list-item-content v-text="data.item"></v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content>
																	<v-list-item-title v-html="data.item.id"></v-list-item-title>
																</v-list-item-content>
															</template>
														</template>
													</v-autocomplete>
												</div>

												<div class="pt-2 mb-2">
													<v-text-field
														label="Password"
														color="primary"
														class="input-regis"
														v-model="params.password"
														hide-details="auto"
														:type="typeInput"
														:append-icon="icon"
														@click:append="showPassword"
														tabindex="5"
														autocomplete="hallooo"
														:rules="rules.password">
													</v-text-field>
												</div>
											</v-card>
										</v-col>
									</v-row>

									<v-card class="pa-3 my-4 elevation-0 rounded-lg" outlined>
										<div class="d-flex flex-row justify-space-between">
											<v-btn text class="mr-2" :loading="btnLoading" @click="goBack()" tabindex="7">
												<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
											</v-btn>

											<v-btn
												color="primary"
												tabindex="6"
												:loading="btnLoading"
												@click="processInput()"
											>
												<v-icon dense class="mr-1">mdi-account-box-multiple-outline</v-icon>
												Kloning Akun
											</v-btn>
										</div>
									</v-card>
								</v-form>
							</v-col>
						</v-scroll-x-reverse-transition>

						<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
							<v-col cols="12" sm="12" md="8" class="pt-5">
								<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
									<div class="font-size-12 cl-primary">Data Personal</div>
									<div class="pt-5">
										<v-row>
											<v-col cols="12" sm="12" md="3">
												<div class="text-center">
													<v-img height="100" width="100" class="user-img mx-auto rounded-pill" :src="(stores_image) ? stores_image : 'assets/image/profile-pict.png'"></v-img>
													<div class="bottom-shadow"></div>
												</div>
											</v-col>
											<v-col cols="12" sm="12" md="4" class="px-4">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Lengkap</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.name | emptyData }}</span>
													</div>
												</div>

												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-email</v-icon>Email</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.email | emptyData }}</span>
													</div>
												</div>

												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-card-account-details</v-icon>No. Ktp</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.identity_no | emptyData }}</span>
													</div>
												</div>

												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-cellphone</v-icon>No. Handphone</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mobilephone | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="5" class="px-4">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-radius-outline</v-icon>Alamat</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.address | emptyData }}</span>
													</div>
												</div>

												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getCityName(params.city_id) }}</span>
													</div>
												</div>

												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Provinsi</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getProvinceName(params.province_id) }}</span>
													</div>
												</div>
											</v-col>
										</v-row>
									</div>
								</v-card>

								<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
									<div class="font-size-12 cl-primary">Data Ahli Waris</div>
									<div class="pt-5">
										<v-row>
											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ibu Kandung</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mother_name | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ahli Waris</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_name | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Hubungan Ahli Waris</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_relation | emptyData }}</span>
													</div>
												</div>
											</v-col>
										</v-row>
									</div>
								</v-card>

								<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
									<div class="font-size-12 cl-primary">Data Bank</div>
									<div class="pt-5">
										<v-row>
											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Rekening</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_name | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account-box-outline</v-icon>Nomor Rekening</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_no | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-bank-outline</v-icon>Nama Bank</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_name | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota Bank</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_city_id | emptyData }}</span>
													</div>
												</div>
											</v-col>

											<v-col cols="12" sm="12" md="4" class="px-0">
												<div class="d-block font-size-10 mb-3 px-2">
													<div class="d-flex flex-column">
														<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Nama Cabang</span>
														<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_branch_name | emptyData }}</span>
													</div>
												</div>
											</v-col>
										</v-row>
									</div>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</v-row>
				</div>
			</template>

			<template v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg text-center">
							<NoData></NoData>
							<div class="d-block py-3 text-center cl-secondary">Data Mitra tidak dapat ditemukan.</div>
							<v-btn text class="my-4" :loading="btnLoadingProses" @click="goBack()">
								<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
							</v-btn>
						</v-card>
					</v-col>
				</v-row>
			</template>
		</template>

		<template v-else>
			<LoadData :loading="loaderData"></LoadData>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSuccess from './components/ModalSuccessCloning'

export default {
	components: {
		ModalSuccess
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			typeInput: 'password',
			icon: 'mdi-eye',
			btnLoadingProses: false,
			btnLoading: false,
			listSerialActivation: [],
			listSerialRegis: [],
			suksesInput: false,
			isActiveMember: true,
			isMitraExist: true,
			stores_image: null,
			paramsId: null,
			pageTitle: '',
			sponsor_name: '',
			sponsor_valid: true,
			upline_name: '',
			upline_valid: true,
			params: {
				network_type: 'bin',
				network_code: '',
				sponsor_code: '',
				upline_code: '',
				position: '',
				membership_serial: '',
				network_serial: '',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				password: '',
				bank_id: '',
				bank_name: '',
				bank_branch_name: '',
				bank_city_id: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				activation_datetime: ''
			},
			rules: {
				input: [
					v => !!v || 'Tidak boleh kosong',
				],
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
				password: [
					v => !!v || 'Tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6 karakter",
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},

	computed: {
		...mapState('auth', ['userData']),
		...mapState('registration', ['responSuksesRegis', 'responseError', 'errorValidation']),
		...mapState('profile', ['myProfile', 'myBank']),
		...mapState('option', ['optProvince', 'optCity']),
	},
	methods: {
		...mapActions('serial', ['getSerialAvailable']),
		...mapActions('registration', ['getMitraByNetworkCode', 'addCloneMitra']),
		...mapActions('option', ['getOptionProvince', 'getOptionCity']),
		...mapActions('profile', ['getProfileMitra']),

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		setSerialData(data) {
			let dataSerial = []
			Object.keys(data).forEach((val) => {
				dataSerial.push({
					header: val.toUpperCase() + ' (' + data[val].length + ')',
				})

				let serial = data[val]
				serial.forEach(item => {
					dataSerial.push({
						id: item.serial_member_stock_serial_id,
						group: val,
						pin: item.serial_member_stock_serial_pin,
						pv: item.serial_member_stock_serial_pv,
						stock_datetime: item.serial_member_stock_datetime,
						exp_datetime: item.serial_member_stock_expired_date,
						isExpired: item.serial_member_stock_is_expired
					})
				});
			})

			return dataSerial
		},

		reset() {
			this.params = {
				member_id: '',
				network_code: '',
				sponsor_code: '',
				upline_code: '',
				position: '',
				network_serial: '',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				bank_id: '',
				bank_name: '',
				bank_branch_name: '',
				bank_city_id: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				activation_datetime: ''
			}
		},

		getMitraSponsorName(mitra_code) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response).length > 0) {
						this.sponsor_name = '[' + response.member_name + ']'
						this.sponsor_valid = true
						setTimeout(() => {
							this.sponsor_name = '[' + response.member_name + ']'
							this.sponsor_valid = true
							if(this.$refs.uplineCode !== undefined) this.$refs.uplineCode.focus()
						}, 200);
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							this.$refs.sponsorCode.focus()
						}, 200);
					}
					this.$refs.sponsorCode.validate()
					// this.$refs.formCloningAccount.validate(['sponsor_code'])
				}).catch(() => {
					this.sponsor_name = ''
					this.sponsor_valid = false
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		getMitraUplineName(mitra_code) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response).length > 0) {
						this.upline_name = '[' + response.member_name + ']'
						this.upline_valid = true
						setTimeout(() => {
							this.upline_name = '[' + response.member_name + ']'
							this.upline_valid = true
							this.$refs.positionL.$el.children[0].children[0].focus()
						}, 200);
					} else {
						this.upline_name = ''
						this.upline_valid = false
						setTimeout(() => {
							this.$refs.uplineCode.focus()
						}, 200);
					}
					this.$refs.uplineCode.validate()
					// this.$refs.formCloningAccount.validate(['upline_code'])
				}).catch(() => {
					this.upline_name = ''
					this.upline_valid = false
				})
			} else {
				this.upline_name = ''
				this.upline_valid = false
			}
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},

		async getProfileData() {
			this.isMitraExist = true
			this.stores_image = this.myProfile.member_image

			this.params = {
				network_type: 'bin',
				sponsor_code: this.$route.query.sponsor,
				upline_code: this.$route.query.upline,
				position: this.$route.query.pos,

				network_serial: '',
				member_id: this.myProfile.member_id,
				network_code: this.myProfile.member_network_code,
				name: this.myProfile.member_name,
				identity_no: this.myProfile.member_identity_no,
				email: this.myProfile.member_email,
				mobilephone: this.myProfile.member_mobilephone,
				bank_id: this.myProfile.member_bank_id,
				bank_name: this.myProfile.member_bank_name,
				bank_branch_name: this.myProfile.member_bank_branch,
				bank_city_id: this.myProfile.member_bank_city,
				account_name: this.myProfile.member_bank_account_name,
				account_no: this.myProfile.member_bank_account_no,
				city_id: this.myProfile.member_city_id,
				province_id: this.myProfile.member_province_id,
				address: this.myProfile.member_address,
				mother_name: this.myProfile.member_mother_name,
				devisor_name: this.myProfile.member_devisor_name,
				devisor_relation: this.myProfile.member_devisor_relation,
				activation_datetime: this.myProfile.member_activation_datetime
			}
		},

		async getData() {
			await this.getProfileMitra()
			await this.getOptionProvince()
			await this.getOptionCity()
			await this.getSerialAvailable().then((response) => {
				if(response) {
					this.listSerialRegis = response.registrasi
					this.listSerialActivation = this.setSerialData(response.aktivasi)
				}
			})
			await this.getProfileData()

			setTimeout(() => {
				this.loaderData = false
			}, 600);
		},

		getCityName(id) {
			if(id && Object.keys(this.optCity).length > 0) {
				if(this.optCity[id] !== undefined) {
					return this.optCity[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},

		getProvinceName(id) {
			if(id && Object.keys(this.optProvince).length > 0) {
				if(this.optProvince[id] !== undefined) {
					return this.optProvince[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},

		goBack() {
			this.$router.push({name: 'genealogy'})
		},

		goActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		async processInput() {
			if (this.$refs.formCloningAccount.validate()) {
				this.btnLoading = await true

				this.params.network_type = await 'bin'
				this.addCloneMitra(this.params).then(() => {
					this.typeRegis = 'mitra'
					this.successCloning(this.responSuksesRegis)
					setTimeout(() => {
						// this.reset()
						this.upline_name = ''
						this.sponsor_name = ''
						this.btnLoading = false
					}, 600);
				}).catch(() => {
					this.btnLoading = false
				})
				this.btnLoading = await false
				// this.loaderData = await true
				// this.getData()
			}
		},

		successCloning(data) {
			if(data) {
				this.msgSuccess = `
					<span class="font-weight-bold cl-primary font-size-12">Akun Mitra Baru Anda telah berhasil didaftarkan di sistem MLM Esoftdream.</span><br>
					<div class="d-block text-center my-4">
						<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${data.name}</strong></span>
						<span class="d-block"><span style="display: inline-block;">Username</span> : <strong>${data.network_code}</strong></span>
						<span class="d-block"><span style="display: inline-block;">Password</span> : <strong>${this.params.password}</strong></span>
					</div>
					Segera login ke website <a href="https://demomlm.esoftdream.co.id/">www.demomlm.esoftdream.co.id/</a> untuk dapat mengakses akun tersebut. Salam sukses bersama <strong>MLM Esoftdream!</strong>
				`
	
				this.$refs.modalSuccess.modalShow()
			}
		}
	},

	async created() {
		this.loaderData = await true
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)
		await this.checkMemberActivation(data)
		if (!this.isActiveMember) this.$router.push({name: 'aktivasi'})

		this.pageTitle = await 'Kloning Akun Mitra'
		await this.$store.dispatch('setPageTitle', this.pageTitle)

		this.getData()
	},

	mounted() {
		if (this.$route.query.sponsor) this.getMitraSponsorName(this.$route.query.sponsor)
		if (this.$route.query.upline) this.getMitraUplineName(this.$route.query.upline)
	},
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}
</style>